module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"see_more":"Show more","see_all":"Read all the reviews"}}')
  delete Component.options._Ctor
}
